import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

const filterByTypeAndSubType = (...types: Array<eCDV3ItemTypes | [eCDV3ItemTypes, any]>) => {
  const typesArray = types.map((type) => (Array.isArray(type) ? type : [type]));
  return (item: ICDV3ViewItem) =>
    !!typesArray.find(
      (pair) => pair[0] === item.type && (!pair[1] || pair[1] === (item as { sub_type?: any }).sub_type)
    );
};

export default filterByTypeAndSubType;
